import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard'; // Import the Clipboard service
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-zitat-dialog',
  templateUrl: './zitat-dialog.component.html',
  styleUrls: ['./zitat-dialog.component.css']
})
export class ZitatDialogComponent {
  zitat: string;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar
  ) {

  }
  
  ngOnInit(){
console.log(this.data.docData);

    if (this.data.docData.docTyp.id == '2') {
      this.zitat = this.data.docData['2_perindex'].content + '. In: Demko – Demokratie kommunal. Die Stadträte von Rheinland-Pfalz in der frühen Nachkriegszeit. ' +  'https://demko.uni-trier.de/app/#/document/' + this.data.docData.ID + ' (Zuletzt bearbeitet am: ' +this.data.docData.timelastchg +  ').';
    }

    if (this.data.docData.docTyp.id == '3') {
      this.zitat = this.data.docData['3_stadt'].content + '. In: Demko – Demokratie kommunal. Die Stadträte von Rheinland-Pfalz in der frühen Nachkriegszeit. ' +  'https://demko.uni-trier.de/app/#/document/' + this.data.docData.ID + ' (Zuletzt bearbeitet am: ' +this.data.docData.timelastchg +  ').';
    }

    if (this.data.docData.docTyp.id == '4') {
      this.zitat = this.data.docData['4_obj_titel0'] + '. In: Demko – Demokratie kommunal. Die Stadträte von Rheinland-Pfalz in der frühen Nachkriegszeit. ' +  'https://demko.uni-trier.de/app/#/document/' + this.data.docData.ID + ' (Zuletzt bearbeitet am: ' +this.data.docData.timelastchg +  ').';
    }

    if (this.data.docData.docTyp.id == '5') {
      this.zitat = this.data.docData['5_erg4wahl'].content + ' in ' + this.data.docData['5_erg4stadt'].content  + '. In: Demko – Demokratie kommunal. Die Stadträte von Rheinland-Pfalz in der frühen Nachkriegszeit. ' +  'https://demko.uni-trier.de/app/#/document/' + this.data.docData.ID + ' (Zuletzt bearbeitet am: ' +this.data.docData.timelastchg +  ').';
    }
  }


  copyZitierrichtlinie(): void {
    const anchorElement = document.createElement('a');
    anchorElement.textContent = this.zitat;
    anchorElement.href = 'https://demko.uni-trier.de/app/#/document/'+ this.data.docData.ID;
    document.body.appendChild(anchorElement);
  
    const range = document.createRange();
    range.selectNode(anchorElement);
    window.getSelection()?.removeAllRanges();
    window.getSelection()?.addRange(range);

    const anchorHtml = anchorElement.outerHTML; // Get the HTML representation as a string

  const successful = this.clipboard.copy(anchorHtml);
    document.body.removeChild(anchorElement);
    window.getSelection()?.removeAllRanges();
  
    if (successful) {
      this.snackBar.open('Zitierrichtlinie wurde kopiert.', 'OK', {
        duration: 3000,
        panelClass: ['success-snackbar']
      });
    } else {
      this.snackBar.open('Fehler beim Kopieren der Zitierrichtlinie.', 'OK', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
    }
  }
  

}
